import type { Retailer as RetailerType } from '../@types/Retailer';
import { getMarket } from '../i18n';

const resolveRoute = () => {
  const { marketCode } = getMarket();
  switch (marketCode) {
    case 'NO':
      return '/forhandler';
    default:
      return '/aterforsaljare';
  }
};

interface ParsedRetailer {
  distance: string | null;
  id: string;
  logo: string;
  name: string;
  url: string;
}

export const parseRetailer = (document: RetailerType): ParsedRetailer => {
  let distance = null;
  if (document.distance) {
    distance = `${document.distance.toFixed(1)} ${document.distanceunit}`;
  }

  return {
    distance,
    id: document.id,
    logo: document.logo,
    name: document.name,
    url: `${resolveRoute()}/${document.slug}`,
  };
};

/*
class Retailer {
  static parse = (document: RetailerType) => {
    let distance = null;
    if (document.distance) {
      distance = `${document.distance.toFixed(1)} ${document.distanceunit}`;
    }

    return {
      distance,
      id: document.id,
      logo: document.logo,
      name: document.name,
      url: `${resolveRoute()}/${document.slug}`,
    };
  };
}

export default Retailer;
*/
